import { useCallback, useEffect } from "react";
export default function useKeyboardEventListener(eventCode, shiftKey, callback) {
    const keyDownCallback = useCallback((event) => {
        if (!(event.target instanceof HTMLInputElement) &&
            !(event.target instanceof HTMLTextAreaElement) &&
            event.code === eventCode &&
            event.shiftKey === shiftKey) {
            callback(event);
        }
    }, [callback]);
    useEffect(() => {
        document.addEventListener("keydown", keyDownCallback);
        return () => {
            document.removeEventListener("keydown", keyDownCallback);
        };
    }, [keyDownCallback]);
}
